export const AppRoutes = {
  PUBLIC_ROUTES: {
    HOME: "/",
    LOGIN: "/login",
    SIGN_UP: "/sign-up",
    OTP_VERIFICATION: "/otp-verification",
    FIND_JOB: "/jobseeker",
    JOBLISTING: '/searched-jobs',
    SPECIFIC_JOB_DETAILS: '/job-details/:id',
    ABUSEPOLICIES: '/abuse-policies',
    TERMANDCONDITIONS: '/term-and-conditions',
    COOKIESPOLICY: '/cookie-policy',
    TRADMARKPOLICY: '/trademark-policy',
    REPORTPROBLEM: '/report-problem',
    PRIVACYPOLICY: '/privacy-policy',
    ABOUTUS: '/about-us',
    CONTACT_US: '/contact-us',
    RESET_PASSWORD: 'org/reset-password/:representativeId',
    REFFERAL_PAGE: '/referral/:token',
    REQUEST_DEMO_PAGE: '/request-demo',
    CHECKOUT_PAGE: 'checkout/:sessionId',
    PAYMENT_SUCCESSFULL: 'payment-status',
    ORGANIZATION_PROFILE: 'organization/:companyname',
    CHAT_PAGE: '/chat',
    PRICING_PAGE:'/pricing',
    NOTEXIST: '*',
  },
  JOBSEEKER_ROUTES: {
    APPLICATION_STATUS: '/jobseeker/dashboard',
    USER_INFO: "/jobseeker/user-info",
    JOB_DETAILS: "/job-details",
    RECOMENDED_JOBS: '/jobseeker/recommended-jobs',
    SAVE_JOBS: '/jobseeker/save-jobs',
    BLOGS: '/jobseeker/blogs',
    REFERENCE_PEOPLE: '/jobseeker/reference-people',
    SETTING: '/jobseeker/setting',
    FIND_JOB_CALENDER: '/jobseeker/calender',
    TICKETS: '/jobseeker/tickets',
    HelpCenter:'/help-center'
  },
  ORGANIZATION_ROUTES: {
    DASHBOARD: '/dashboard',
    ORGANIZATION_INFO: '/organization-info',
    JOB_STATUS: '/job-status',
    RECOMMEND_CANDIDATE: '/recommend-candidate',
    ANALYTICS: '/analytics',
    ORG_SETTINGS: '/organization-settings',
    ORG_CALENDER: '/organization-calender',
    CANDIDATE_DETAILS: '/candidate-details/:id',
    RECOMMEND_CANDIDATE_PROFILE: '/candidate-profile/:id',
    CANDIDATE_DETAILS_INFO_PAGE: '/org/candidate-details/:jobId/:userId',
  }
};